var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('StoCscResultHeader',{attrs:{"listLength":_vm.itemList.length}}),_c('div',{staticClass:"row px-4 py-5 pt-lg-0"},_vm._l((_vm.itemList),function(item,index){return _c('StoCscResultItemGrid',{key:index,attrs:{"item":item,"index":index}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }